const initialState = {
  fetchingBook: false,
  book: null,
  bookError: false,
  bookNotFound: false
};

export default function books(state = initialState, action) {
  switch (action.type) {
    case 'FETCHING_BOOK':
      return {
        ...state,
        fetchingBook: true
      };
    case 'RECEIVE_BOOK':
      return {
        ...state,
        fetchingBook: false,
        bookError: false,
        book: action.book
      };
    case 'BOOK_NOT_FOUND':
      window.location.href = '/404';

      return {
        fetchingBook: false,
        bookError: false,
        book: null,
        bookNotFound: true
      };
    case 'BOOK_ERROR':
      window.location.href = '/404';

      return {
        fetchingBook: false,
        bookError: true,
        book: null
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/book.js